import { createI18n } from 'vue-i18n';
import zhCN from './locales/zh_CH';
import enUS from './locales/en_US';

let language = window.localStorage.getItem('merchant_language') || 'eng';

const i18n = createI18n({
    legacy: false,
    locale: language, // 默认显示语言
    messages: {
        'chn': zhCN,
        'eng': enUS
    }
});

export default i18n;